import React from 'react';
import {InnerProps} from './model';
import {Platform, View} from 'react-native';
import {Field} from 'redux-form';
import {BaseField} from '../../../../../shared/components/baseField';
import {Button} from '../../../../../shared/components/button';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Form} from '../../../../../shared/components/form';

export default (props: InnerProps) => {
  // хак для веба, по-другому пока не понятно как решать, стили созданые stylesheet из react-native
  // не прокидываются в material-ui textfield который на вебе.
  const fieldStyle = {
    width: '100%' as const,
  };

  const styles = useStyles(() => {
    return {
      eyeContainer: {
        width: 40,
        height: 40,
        paddingTop: 16,
        display: 'flex' as const,
        alignItems: 'flex-end' as const,
      },
      sectionContainer: {
        marginTop: 21,
        paddingLeft: 24,
        paddingRight: 24,
      },
      buttonContainer: {
        display: 'flex' as const,
        flexDirection: 'row' as const,
        width: '100%' as const,
        justifyContent: 'center' as const,
        marginTop: 40,
      },
      button: {width: 290, maxWidth: '100%' as const},
      fieldRow: {
        marginTop: 16,
      },
      fieldStyle,
    };
  });

  return (
    <Form style={styles.sectionContainer} onSubmit={props.onSubmit}>
      <Field
        label='Текущий пароль'
        component={BaseField}
        type='password'
        name='oldPassword'
        style={Platform.OS === 'web' ? fieldStyle : styles.fieldStyle}
        onSubmitEditing={props.onSubmit}
      />
      <View style={styles.fieldRow}>
        <Field
          label='Новый пароль'
          type='password'
          component={BaseField}
          name='newPassword'
          style={Platform.OS === 'web' ? fieldStyle : styles.fieldStyle}
          onSubmitEditing={props.onSubmit}
        />
      </View>
      <View style={styles.fieldRow}>
        <Field
          label='Повторите пароль'
          component={BaseField}
          type='password'
          name='confirmPassword'
          style={Platform.OS === 'web' ? fieldStyle : styles.fieldStyle}
          onSubmitEditing={props.onSubmit}
        />
      </View>
      <View style={styles.buttonContainer}>
        <Button id='profile-change-password-save' style={styles.button} onPress={props.onSubmit} text='Сохранить' />
      </View>
    </Form>
  );
};
